import { render, staticRenderFns } from "./RewardProgram.vue?vue&type=template&id=7952da55"
import script from "./RewardProgram.vue?vue&type=script&lang=js"
export * from "./RewardProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports